import { Role } from "./role.model";

export class User {
    public id: number;
    public email: string;
    public name: string;
    public surname: string;
    public phone?: string;
    public is_admin?: number;
    public recbot_api_token?: string;
    public namedType?: string;
    public role?: Role;

    constructor(
        id: number, 
        email: string, 
        name: string, 
        surname: string,
        is_admin?: number,
        phone?: string,  
        recbot_api_token?: string, 
        role?: Role,
    ) {
        this.id = id;
        this.email = email;
        this.name = name;
        this.surname = surname;
        this.phone = phone;
        this.is_admin = is_admin;
        this.recbot_api_token = recbot_api_token;
        this.namedType = (this.is_admin === 0) ? "USER" : "ADMIN"
        this.role = role;
    }
}